<template>
  <div style="width: 100%; height: 100%" ref="elEcharts" />
</template>
<script setup lang="ts">
import { shallowRef, onMounted, watch } from "vue"
import { useEcharts, type EChartsCoreOption } from "@/hooks/useHookEchart"

interface Props {
  options: EChartsCoreOption
}
const props = defineProps<Props>()
const elEcharts = shallowRef()
const currentOptions = shallowRef(props.options)
const { setOptions, initCharts } = useEcharts(elEcharts, currentOptions.value)

watch(
  () => props.options,
  (nVal) => {
    let targetOptions: EChartsCoreOption = {}
    targetOptions = { ...nVal }
    setOptions(targetOptions)
  }
)

onMounted(() => {
  initCharts()
})
</script>